import React from 'react';
import { Affirmation } from '../types/angelNumber';
export function AffirmationCard({
  affirmation
}: {
  affirmation?: Affirmation;
}) {
  if (!affirmation?.text?.trim()) return null;
  return <section className="relative overflow-hidden rounded-3xl border border-gold/25 px-6 py-7 text-center" style={{
    background: 'linear-gradient(180deg, rgba(139,92,246,0.16) 0%, rgba(13,17,48,0.86) 100%)',
    boxShadow: '0 22px 50px -32px rgba(0,0,0,0.9)'
  }} data-id="element-19" data-mp="va1h05yp9rzg">
      <span aria-hidden="true" className="aura-pulse absolute left-1/2 top-[-6rem] h-48 w-48 -translate-x-1/2 rounded-full" style={{
      background: 'radial-gradient(circle, rgba(217,192,140,0.28) 0%, rgba(5,6,15,0) 70%)'
    }} data-id="element-20" data-mp="109ecff3n07dn" />
      <p className="relative text-[11px] font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-21" data-mp="192zpmu05lgky">
        Affirmation
      </p>
      <p className="relative mt-4 text-[18px] font-light leading-snug text-white" data-id="element-22" data-mp="1izcmg0qzwajx">
        “{affirmation.text}”
      </p>
    </section>;
}